import React, { useEffect, useState, useMemo } from 'react';
import {
  Skeleton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Box
} from '@mui/material';
import { Report } from '../../models/report';

// Function to normalize Vietnamese text
const normalizeVietnamese = (str) => {
  return str
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D');
};

const ReportEmbed = (props) => {
  const [loading, setLoading] = useState(true);
  const [report, setReport] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');

  useEffect(() => {
    const fetchReport = async () => {
      try {
        props.setPageTitle('Danh sách hàng tồn');
        const data = await Report.fetch('inventory');
        console.log(data);
        setReport(data);
      } catch (error) {
        console.error('Error fetching report URL:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchReport();
  }, []);

  const filteredProducts = useMemo(() => {
    if (!report?.products) return [];
    const normalizedQuery = normalizeVietnamese(searchQuery);
    return report.products.filter(product =>
      normalizeVietnamese(product.product_name).includes(normalizedQuery)
    );
  }, [report?.products, searchQuery]);

  if (loading) {
    return <Skeleton variant="rectangular" width="100%" height={600} />;
  }

  if (!report) {
    return <p>Không tìm thấy báo cáo.</p>;
  }

  return (
    <Box sx={{ maxWidth: 1200, margin: '24px auto' }}>
      <TextField
        fullWidth
        label="Tìm kiếm sản phẩm"
        variant="outlined"
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
        sx={{ mb: 2 }}
      />
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="inventory table">
          <TableHead>
            <TableRow>
              <TableCell>STT</TableCell>
              <TableCell>Tên sản phẩm</TableCell>
              <TableCell align="right">Số lượng tồn</TableCell>
              <TableCell align="right">Số lượng nhập trong ngày</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {filteredProducts.map((row, index) => (
              <TableRow
                key={row.product_id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell>{index + 1}</TableCell>
                <TableCell>{row.product_name}</TableCell>
                <TableCell align="right">{row.total_quantity}</TableCell>
                <TableCell align="right">{row.addition_quantity}</TableCell>
              </TableRow>
            ))
            }
          </TableBody >
        </Table >
      </TableContainer>
    </Box >
  );
};

export default ReportEmbed;
